import { type PropsWithChildren } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export function PageContainer({
  children,
  className,
  disableOverflow = false,
  variant = "lp",
  removePageContainerPadding = false,
}: PropsWithChildren & {
  className?: string;
  disableOverflow?: boolean;
  variant?: "gp" | "lp";
  removePageContainerPadding?: boolean;
}) {
  return (
    <div
      className={cnTwMerge(
        "relative w-full mx-auto flex flex-1 flex-col defaultTransition",

        {
          "over-visible sm:over-visible w-0": disableOverflow,
          "overflow-hidden": !disableOverflow,
          "px-0": removePageContainerPadding,
          "container-padding-lp":
            !removePageContainerPadding && variant === "lp",
          "container-padding-gp":
            !removePageContainerPadding && variant === "gp",
        },
        className,
      )}
      data-testid="pageContainer"
      id="pageContainer"
    >
      {children}
    </div>
  );
}
